// HERBLABS product catalog — 3 divisions, subcategories, groups & products.

export const DIVISIONS = [
  {
    id: "botanical",
    index: "01",
    name: "Botanical Ingredients",
    tagline: "Herbal powders, extracts, functional ingredients & pure essential oils.",
    image:
      "https://images.unsplash.com/photo-1633509817627-5a29634475af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxoZXJiYWwlMjBwb3dkZXIlMjBib3RhbmljYWwlMjBleHRyYWN0c3xlbnwwfHx8fDE3ODUwNjI5Nzd8MA&ixlib=rb-4.1.0&q=85",
    accent: "#4A5D4E",
    subcategories: [
      {
        name: "Herbal Powders",
        groups: [
          { label: "Adaptogenic Herbs", items: ["Ashwagandha Powder", "Shatavari Powder", "Safed Musli Powder", "Brahmi Powder", "Tulsi Powder", "Giloy Powder", "Kalmegh Powder", "Jatamansi Powder", "Mulethi Powder", "Arjuna Bark Powder"] },
          { label: "Superfoods", items: ["Moringa Leaf Powder", "Amla Powder", "Wheatgrass Powder", "Barley Grass Powder", "Spirulina Powder", "Chlorella Powder", "Beetroot Powder", "Spinach Powder"] },
          { label: "Digestive Herbs", items: ["Triphala Powder", "Bael Powder", "Isabgol (Psyllium Husk Powder)", "Fennel Powder", "Ajwain Powder", "Ginger Powder"] },
          { label: "Detox Herbs", items: ["Neem Powder", "Turmeric Powder", "Curry Leaf Powder", "Aloe Vera Powder"] },
          { label: "Women's Wellness", items: ["Lodhra Powder", "Ashoka Bark Powder", "Shatavari Powder"] },
          { label: "Men's Wellness", items: ["Gokshura Powder", "Kaunch Beej Powder", "Safed Musli Powder"] },
          { label: "Functional Fruit Powders", items: ["Pomegranate Powder", "Guava Powder", "Mango Powder", "Banana Powder", "Lemon Powder", "Orange Powder"] },
          { label: "Vegetable Powders", items: ["Tomato Powder", "Onion Powder", "Garlic Powder", "Carrot Powder", "Pumpkin Powder"] },
        ],
      },
      {
        name: "Herbal Extracts",
        groups: [
          { label: "Adaptogens", items: ["Ashwagandha Extract", "Rhodiola Extract", "Panax Ginseng Extract", "Siberian Ginseng Extract"] },
          { label: "Cognitive", items: ["Bacopa Extract", "Ginkgo Biloba Extract", "Lion's Mane Extract", "Gotu Kola Extract"] },
          { label: "Anti-inflammatory", items: ["Curcumin Extract", "Boswellia Extract", "Ginger Extract", "Turmeric Extract"] },
          { label: "Immunity", items: ["Amla Extract", "Elderberry Extract", "Echinacea Extract", "Tulsi Extract"] },
          { label: "Metabolic Health", items: ["Gymnema Extract", "Bitter Melon Extract", "Fenugreek Extract", "Cinnamon Extract"] },
          { label: "Liver Health", items: ["Milk Thistle Extract", "Kalmegh Extract", "Kutki Extract"] },
          { label: "Beauty", items: ["Grape Seed Extract", "Green Tea Extract", "Pine Bark Extract"] },
          { label: "Others", items: ["Moringa Extract", "Neem Extract", "Stevia Extract", "Aloe Vera Extract", "Shilajit Extract", "Safed Musli Extract"] },
        ],
      },
      {
        name: "Functional Ingredients",
        groups: [
          { label: "Fibres & Gums", items: ["Psyllium Husk", "Psyllium Husk Powder", "Psyllium Seeds", "Inulin", "Resistant Dextrin", "Acacia Fiber", "Guar Gum", "Xanthan Gum", "Pectin", "Konjac Powder", "Apple Fiber", "Citrus Fiber", "Bamboo Fiber", "Chicory Root Fiber", "Flaxseed Meal", "Chia Seeds", "Oat Fiber"] },
        ],
      },
      {
        name: "Essential Oils & Oleoresins",
        groups: [
          { label: "Essential Oils", items: ["Peppermint Oil", "Lemongrass Oil", "Eucalyptus Oil", "Tea Tree Oil", "Lavender Oil", "Citronella Oil", "Basil Oil", "Tulsi Oil", "Rosemary Oil", "Sandalwood Oil", "Vetiver Oil", "Patchouli Oil", "Clove Oil", "Cinnamon Oil", "Ginger Oil", "Turmeric Oil", "Black Pepper Oil", "Cardamom Oil", "Orange Oil", "Lemon Oil"] },
          { label: "Oleoresins", items: ["Black Pepper Oleoresin", "Turmeric Oleoresin", "Paprika Oleoresin", "Ginger Oleoresin", "Chilli Oleoresin", "Cardamom Oleoresin", "Cinnamon Oleoresin", "Clove Oleoresin", "Cumin Oleoresin", "Coriander Oleoresin", "Nutmeg Oleoresin"] },
        ],
      },
    ],
  },
  {
    id: "agri",
    index: "02",
    name: "Agri Commodities",
    tagline: "Spices, grains, pulses, nuts, natural sweeteners & cold-pressed oils.",
    image:
      "https://images.unsplash.com/photo-1581600140682-d4e68c8cde32?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxzcGljZXMlMjBncmFpbnMlMjBuYXR1cmFsfGVufDB8fHx8MTc4NTA2Mjk3N3ww&ixlib=rb-4.1.0&q=85",
    accent: "#B85D43",
    subcategories: [
      {
        name: "Spices & Seeds",
        groups: [
          { label: "Whole Spices", items: ["Turmeric Fingers", "Black Pepper", "White Pepper", "Cardamom", "Cinnamon", "Clove", "Nutmeg", "Mace", "Star Anise", "Bay Leaf"] },
          { label: "Seed Spices", items: ["Mustard Seeds", "Cumin Seeds", "Coriander Seeds", "Fennel Seeds", "Fenugreek Seeds", "Nigella Seeds", "Dill Seeds", "Carom Seeds (Ajwain)", "Celery Seeds"] },
          { label: "Spice Powders", items: ["Turmeric Powder", "Ginger Powder", "Garlic Powder", "Onion Powder", "Red Chilli Powder", "Coriander Powder", "Cumin Powder", "Black Pepper Powder"] },
        ],
      },
      {
        name: "Grains",
        groups: [
          { label: "Basmati Rice", items: ["Traditional Basmati Rice", "1121 Basmati", "1509 Basmati", "Pusa Basmati", "Sella Basmati", "Steam Basmati", "Brown Basmati", "Organic Basmati"] },
          { label: "Non-Basmati Rice", items: ["Sona Masoori", "IR64"] },
          { label: "Millets", items: ["Pearl Millet", "Finger Millet", "Foxtail Millet", "Little Millet", "Kodo Millet", "Barnyard Millet", "Proso Millet", "Sorghum"] },
          { label: "Wheat", items: ["Durum Wheat", "Sharbati Wheat", "MP Wheat", "Whole Wheat Flour", "Semolina"] },
        ],
      },
      {
        name: "Dry Fruits & Nuts",
        groups: [
          { label: "Nuts", items: ["Almonds", "Cashews", "Walnuts", "Pistachios", "Pecans", "Hazelnuts", "Macadamia", "Pine Nuts"] },
          { label: "Dry Fruits", items: ["Raisins", "Dates", "Dried Figs", "Apricots", "Prunes", "Cranberries", "Blueberries", "Goji Berries"] },
        ],
      },
      {
        name: "Natural Sweeteners",
        groups: [
          { label: "Honey", items: ["Raw Honey", "Organic Honey", "Forest Honey", "Acacia Honey", "Mustard Honey", "Eucalyptus Honey", "Multi-Floral Honey"] },
          { label: "Jaggery & Sugars", items: ["Jaggery Powder", "Jaggery Cubes", "Jaggery Blocks", "Palm Jaggery", "Coconut Sugar", "Date Sugar"] },
          { label: "Stevia", items: ["Stevia Leaf Powder", "Stevia Extract"] },
        ],
      },
      {
        name: "Pulses & Organic Dry Beans",
        groups: [
          { label: "Lentils", items: ["Masoor Dal", "Toor Dal", "Moong Dal", "Urad Dal", "Chana Dal"] },
          { label: "Whole Pulses", items: ["Green Gram", "Black Gram", "Chickpeas", "Kabuli Chickpeas", "Desi Chickpeas"] },
          { label: "Beans", items: ["Kidney Beans", "Black Beans", "White Beans", "Pinto Beans", "Cowpeas", "Black-Eyed Peas", "Horse Gram", "Moth Beans"] },
        ],
      },
      {
        name: "Cold-Pressed Mustard Oil",
        groups: [
          { label: "Variants", items: ["Yellow Mustard Oil", "Black Mustard Oil", "Organic Cold-Pressed Mustard Oil", "Filtered Mustard Oil", "Wooden Ghani Mustard Oil", "Bulk Industrial Mustard Oil"] },
        ],
      },
    ],
  },
  {
    id: "value-added",
    index: "03",
    name: "Value-Added Products",
    tagline: "Finished nutraceutical formulations, herbal teas & premium coffee.",
    image:
      "https://images.pexels.com/photos/36450276/pexels-photo-36450276.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    accent: "#D4A373",
    subcategories: [
      {
        name: "Nutraceutical Formulations",
        groups: [
          { label: "Capsules", items: ["Ashwagandha Capsules", "Curcumin Capsules", "Moringa Capsules", "Neem Capsules", "Spirulina Capsules", "Triphala Capsules", "Liver Support Capsules", "Immunity Capsules", "Men's Health Capsules", "Women's Wellness Capsules"] },
          { label: "Tablets", items: ["Multivitamin Tablets", "Calcium Tablets", "Vitamin C Tablets", "Herbal Immunity Tablets", "Digestive Tablets", "Joint Support Tablets", "Sleep Support Tablets"] },
        ],
      },
      {
        name: "Herbal Tea & Premium Coffee",
        groups: [
          { label: "Herbal Teas", items: ["Moringa Tea", "Tulsi Tea", "Ashwagandha Tea", "Chamomile Tea", "Hibiscus Tea", "Ginger Tea", "Lemongrass Tea", "Peppermint Tea", "Green Tea", "Detox Tea"] },
          { label: "Premium Coffee", items: ["Arabica Coffee Beans", "Robusta Coffee Beans", "Plantation Coffee", "Organic Coffee", "Instant Coffee", "Freeze-Dried Coffee"] },
        ],
      },
    ],
  },
];

// Flat list of divisions for the "Product of Interest" select.
export const PRODUCT_INTEREST_OPTIONS = [
  "Botanical Ingredients",
  "Agri Commodities",
  "Value-Added Products",
  "General / Multiple",
];

export const CERTIFICATIONS = [
  { code: "APEDA", label: "APEDA Registered", note: "Agricultural & Processed Food Products Export Development Authority" },
  { code: "Spices Board", label: "Spices Board RCMC", note: "Registration-Cum-Membership Certificate" },
  { code: "AYUSH", label: "AYUSH RCMC", note: "Ministry of AYUSH export registration" },
  { code: "FSSAI", label: "FSSAI Compliant", note: "Food Safety & Standards Authority of India" },
];

export const SPEC_TABLE = [
  { param: "Moisture Content", method: "Loss on Drying", typical: "≤ 8%" },
  { param: "Particle Size (Powders)", method: "Mesh Sieve", typical: "80–100 Mesh" },
  { param: "Heavy Metals", method: "ICP-MS", typical: "Within EU / USP limits" },
  { param: "Microbial (Total Plate)", method: "Plate Count", typical: "< 10,000 CFU/g" },
  { param: "Pesticide Residue", method: "GC-MS / LC-MS", typical: "Meets EU MRL" },
  { param: "Extract Standardisation", method: "HPLC", typical: "Actives % on request" },
  { param: "Shelf Life", method: "Accelerated Study", typical: "18–24 Months" },
  { param: "Documentation", method: "Per Shipment", typical: "COA · Phytosanitary · Traceability" },
];

export const TAGLINES = [
  "India's Natural Best — Delivered to the World",
  "Pure Origins. Verified Quality. Global Reach.",
  "From India's Fields to Your Formula",
  "Farm-to-Shipment Traceability",
  "Trusted Herbal & Agri Exports",
];
